export default "__VITE_ASSET__4a96ba90__"